function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SelectionSummaryCtrl = function SelectionSummaryCtrl() {
  _classCallCheck(this, SelectionSummaryCtrl);
};

export default SelectionSummaryCtrl;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/fnol/cp/components/SelectionSummary/SelectionSummaryCtrl.js
// module id = 1530
// module chunks = 0